import React from "react";
import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

export const ThemeToggle = ({ className = "" }) => {
  const { isLight, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label="Changer de thème"
      className={`relative w-10 h-10 grid place-items-center rounded-sm border border-white/15 hover:border-aurora-cyan/50 transition-colors ${className}`}
    >
      {isLight ? <Moon className="w-[18px] h-[18px] text-aurora-cyan" /> : <Sun className="w-[18px] h-[18px] text-aurora-cyan" />}
    </button>
  );
};
